import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PayInput from '../pay/PayInput';
import './ChangePayPwd.scss';

class ChangePayPwd extends Component {
  state = {
    cardId: '',
    isInputDone: false,
  }

  cardIdChange = (event) => {
    this.setState({
      cardId: event.target.value
    }, () => {
      if (this.state.cardId.length >= 15) {
        this.setState({
          isInputDone: true
        })
        this.props.cardIdSureBack(this.state.cardId);
      } else {
        this.setState({
          isInputDone: false
        })
      }
    })
  }

  pwdSureBack = (value, bool) => {
    this.setState({
      isInputDone: bool
    }, () => {
      if (bool) {
        this.props.pwdSureBack(value);
      }
    })
  }

  render () {
    return (
      <div className='changePwd'>
        <div className='changePwd-title'>{this.props.title}</div>
        <div className='changePwd-subTitle'>{this.props.subTitle}</div>
        {this.props.isCardId ? <div className='changePwd-cardId'>
          <input placeholder='请输入身份证号' type="text" value={this.state.cardId} onChange={this.cardIdChange} />
        </div> :
        <div className='changePwd-input'>
          <PayInput pwdError={this.props.pwdError} pwdSureBack={this.pwdSureBack} height='0.82rem' marginRight='0.26rem'></PayInput>
        </div>}
        <div className={`changePwd-btn ${this.state.isInputDone ? 'high' : ''}`} onClick={this.state.isInputDone ? this.props.nextStep : () => {return false}}>
          <span>{this.props.btnTitle}</span>
        </div>
      </div>
    )
  }
}

ChangePayPwd.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  btnTitle: PropTypes.string,
  isCardId: PropTypes.bool,
  pwdError: PropTypes.bool,
  pwdSureBack: PropTypes.func,
  cardIdSureBack: PropTypes.func,
  nextStep: PropTypes.func
}

export default ChangePayPwd;